import { Tracking } from './../../providers/tracking';
import { ToastMessage } from './../../providers/toast-message';
import { ApiV1 } from './../../providers/api-v1';
import { ElesPage } from './../eles/eles';

import { MyFirebase } from './../../providers/my-firebase';
import { UserPage } from './../user/user';
import { Component, NgZone } from '@angular/core';
import { ActionSheetController, AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';

import firebase from 'firebase';

/**
 * Users page
 */
// @IonicPage()
@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
})
export class UsersPage extends ElesPage{

  
  // Ref Firebase list  
  public elesRef = firebase.database().ref('/users');


  // Add page
  addPage = UserPage;

  // Update page
  updatePage = UserPage;


  // Filter
  doFilter(ele, index, array) :boolean {

    if (this.doFilterRegExp == null) return true;
    if ( ele.value.email == null) return true;
    try { 
      if (this.doFilterRegExp instanceof String) return ele.value.email.search( this.doFilterRegExp ) != -1;
      return this.doFilterRegExp.test(ele.value.email);
    } catch(e) {  }

    return true;
  }


  constructor(public navCtrl: NavController, public navParams: NavParams, 
              public alertCtrl: AlertController, public actionSheetCtrl: ActionSheetController,
              public myFirebase : MyFirebase, public apiV1 : ApiV1,
              public toastMsg: ToastMessage, private ngZone: NgZone, public tracking : Tracking) {

    super(navCtrl, navParams, alertCtrl, actionSheetCtrl, myFirebase );

  }

  ionViewDidEnter() {
    this.tracking.view(this);
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad UsersPage');    
    super.ionViewDidLoad();
  }
 
  ionViewWillUnload() {
    console.log('ionViewWillUnload UsersPage');
    super.ionViewWillUnload();
  }

  
  addOrUpdate(eleId, ele) : firebase.Promise<any> {

    // Update ?
    if(eleId) {

      return this.apiV1.updateUser(eleId, ele).then( (user) => { 
    
        delete ele.password;
        return super.addOrUpdate(eleId, ele);
      }).then(()=>{
        this.toastMsg.success("User update: " + ele.email);
      })
      .catch((err)=>{
        this.toastMsg.error("Error update user", err);
      });
    } 

    // Add
    return this.apiV1.createUser(ele).then( (user) => { 

      delete ele.password;
      return super.addOrUpdate(user.uid, ele);

    }).then(()=>{
      this.toastMsg.success("User create: " + ele.email);
    })
    .catch((err)=>{
      this.toastMsg.error("Error create new user", err);
    });

  }


  delete(eleId, ele) : firebase.Promise<any> {   

    return this.apiV1.deleteUser(eleId).then( (user) => { 

      return super.delete(eleId, ele);

    }).then( ()=>{
      this.toastMsg.success("User delete :" + ele.email);
    })
    .catch((err)=>{
      this.toastMsg.error("Error delete user", err);
    });
  }

}




// WEBPACK FOOTER //
// ./src/pages/users/users.ts